module.exports = __webpack_public_path__ + "static/data_source_appearance-feb270e1b9175efd26d43019038d861f.png";